module.exports = __webpack_public_path__ + "static/img/gq1.3a038afd.png";